import { styled } from '@mui/material';

export const Container = styled('div')({
  backgroundColor: '#004763',
  width: 194,
  height: 44,
  boxSizing: 'border-box',
  margin: '0 18px',
  padding: '5px 10px 5px 10px',
  borderRadius: 10,
  position: 'relative',
  '.MuiSvgIcon-root': {
    position: 'absolute',
    right: 10,
    top: 10,
    pointerEvents: 'none'
  },
  label: {
    display: 'block',
    color: '#fff',
    fontFamily: 'Roboto',
    fontSize: 10,
    fontWeight: 400,
    position: 'absolute',
    top: 6,
    left: 10,
    pointerEvents: 'none'
  },
  input: {
    color: '#fff',
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    boxSizing: 'border-box',
    padding: '20px 36px 10px 10px',
    fontFamily: 'Roboto',
    fontSize: 12,
    fontWeight: 600,
    background: 'transparent',
    border: 'none',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    cursor: 'pointer',
    '&:focus': {
      outline: 'none'
    }
  }
});

export const Listbox = styled('ul')({
  top: 57,
  left: 0,
  margin: 0,
  padding: 0,
  zIndex: 1,
  position: 'absolute',
  listStyle: 'none',
  backgroundColor: '#fff',
  overflow: 'auto',
  width: 223,
  maxHeight: '277px',
  borderRadius: 10,
  border: '1px solid #D9D9D9',
  scrollbarColor: '#004763 transparent',
  scrollbarWidth: 'thin',
  li: {
    cursor: 'pointer',
    padding: '14px 14px 0',
    color: '#000',
    fontFamily: 'Roboto',
    fontSize: 12,
    fontWeight: 600,
    hr: {
      margin: 0,
      border: 0,
      height: 1,
      backgroundColor: '#D9D9D980'
    },
    '&:last-child': {
      hr: {
        display: 'none'
      }
    },
    '.location-name': {
      cursor: 'pointer',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      direction: 'rtl'
    },
    '.location-info': {
      paddingTop: 4,
      marginBottom: 10,
      fontSize: 10,
      fontWeight: 400
    },
    '&.Mui-focused, &[aria-selected=true]': {
      cursor: 'pointer',
      color: '#004763'
    }
  },
  '.separator': {
    margin: '0 10px',
    width: 1,
    height: 7,
    backgroundColor: '#D9D9D9',
    display: 'inline-block'
  }
});
